import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCategoryDetails } from "../../../../redux/actions/campaignActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
import "../../../../components/common/css/add.scss";

const CategoryView = () => {
  const token = localStorage.getItem("accessToken");

  const [loading, setLoading] = useState(false);
  const id = useParams();
  const dispatch = useDispatch();
  const categoryView = useSelector((state) => state.categoryView);
  const { category } = categoryView;

  useEffect(() => {
    dispatch(getCategoryDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (categoryView) {
      if (categoryView?.loading !== undefined) {
        setLoading(categoryView?.loading);
      }
    }
  }, [categoryView]);

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="bottom">
          <div className="modal-content">
            <div className="modal-content-title">View Category</div>
            <p>&nbsp;</p>
            <form>
              <div className="custome-form-group">
                <label>Category Name</label>
                <input
                  type="text"
                  name="name"
                  value={category?.data?.category_name}
                  disabled={true}
                  placeholder="Enter Category Name"
                  className="custome-input"
                />
              </div>
              <div className="custome-form-group">
                <label>Category Title</label>
                <input
                  type="text"
                  name="title"
                  value={category?.data?.category_title}
                  placeholder="Enter Category Title"
                  disabled={true}
                  className="custome-input"
                />
              </div>
              <div className="custome-form-group">
                <label>Category Description</label>
                <textarea
                  minRows={5}
                  className="custome-input"
                  name="description"
                  value={category?.data?.category_description}
                  disabled={true}
                  placeholder="Enter Category Description"
                ></textarea>
              </div>
              <button type="submit" className="approveButton" disabled={true}>
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryView;
